import { alpha, Components, Theme } from "@mui/material";

export const MuiOutlinedInput: Components<
  Omit<Theme, "MuiOutlinedInput">
>["MuiOutlinedInput"] = {
  styleOverrides: {
    input: () => ({
      padding: "24px 16px 8px",
    }),
    root: ({ theme: { spacing, palette } }) => ({
      "& .MuiInputAdornment-root": {
        alignItems: "center",
        height: "100%",
        marginTop: 0,
        marginBottom: 0,
      },

      "& .MuiInputAdornment-positionEnd": {
        marginRight: spacing(1),
      },
      "& .MuiInputAdornment-positionStart": {
        marginLeft: spacing(1),
      },

      "& .MuiIconButton-root": {
        padding: 6,
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: palette.custom.purple[200],
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: palette.custom.purple[200],
        boxShadow: `0 0 0 3px ${alpha(palette.custom.purple[200], 0.15)}`,
      },
      "&.Mui-error .MuiOutlinedInput-notchedOutline": {
        borderColor: palette.custom.red[700],
      },

      "&:hover:before, &:before, &:after": {
        display: "none",
        border: "none",
      },
    }),

    notchedOutline: {
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
    },
  },
};
